import React from "react";
import { Avatar } from "@mui/material";
import { Accordion, Col, Row } from "react-bootstrap";
import {
  IconTicket,
  IconTicket1,
  IconNoTicket,
} from "../../../../_metronic/css/icons";
function TickeInfoBox({ item }) {
  console.log("ss", item);
  return (
    <>
      <Accordion.Header className=" rounded-3">
        <Row className="w-100 ">
          <Col xs lg="auto" className="text-left my-auto pr-0">
            <div> {item.basketUser}</div>
            <div className="pt-1">{item.basketUser2}</div>
          </Col>
          <Col xs lg="auto" className="text-start my-auto">
            {item.userMobile}
          </Col>
          <Col
            xs="auto"
            className="d-flex justify-content-end my-auto"
            style={{ width: "65px" }}
          >
            {item.invalidTicketCount > 0 && (
              <Avatar
                sx={{
                  width: 20,
                  height: 20,
                  bgcolor: "#fa1b4329",
                  color: "#fa1b4394",
                }}
              >
                {item.invalidTicketCount}
              </Avatar>
            )}

            {item.bookedTicketCount > 0 && (
              <Avatar
                sx={{
                  width: 20,
                  height: 20,
                  bgcolor: "#09a46333",
                  color: "#09a463d6",
                }}
              >
                {item.bookedTicketCount}
              </Avatar>
            )}
          </Col>
        </Row>
      </Accordion.Header>
      <Accordion.Body className="border-top px-0 px-sm-5">
        <div className="d-flex justify-content-between">
          <div>
            <Row className="text-green">
              <Col xs="12" sm className="nowrap text-center f-08">
                <span className="small-svg mr-1 d-none d-sm-inline-block">
                  <IconTicket1 />
                </span>
                آماده استفاده
              </Col>
              <Col xs="12" sm className="nowrap mt-2 mt-sm-0 text-center">
                <span className="fw-bold mx-1">{item.bookedTicketCount}</span>{" "}
                بلیط
              </Col>
            </Row>
          </div>
          <div>
            <Row className="text-red">
              <Col xs="12" sm className="nowrap text-center f-08">
                <span className="small-svg mr-1 d-none d-sm-inline-block">
                  <IconTicket />
                </span>
                استفاده شده
              </Col>
              <Col xs="12" sm className="nowrap mt-2 mt-sm-0 text-center">
                <span className="fw-bold mx-1">{item.invalidTicketCount}</span>{" "}
                بلیط
              </Col>
            </Row>
          </div>
          <div>
            <Row className="text-red">
              <Col xs="12" sm className="nowrap text-center f-08">
                <span className="small-svg mr-1 d-none d-sm-inline-block">
                  <IconTicket />
                </span>
                استفاده شده امروز
              </Col>
              <Col xs="12" sm className="nowrap mt-2 mt-sm-0 text-center">
                <span className="fw-bold mx-1">
                  {item.todayInvalidTicketCount}
                </span>{" "}
                بلیط
              </Col>
            </Row>
          </div>
          <div>
            <Row className="text-orange">
              <Col xs="12" sm className="nowrap text-center f-08">
                <span className="small-svg mr-1 d-none d-sm-inline-block">
                  <IconNoTicket />
                </span>
                کنسل شده
              </Col>
              <Col xs="12" sm className="nowrap mt-2 mt-sm-0 text-center">
                <span className="fw-bold mx-1">
                  {item.cancelledTicketCount}
                </span>{" "}
                بلیط
              </Col>
            </Row>
          </div>
        </div>
        <div className="border-top px-3 text-gray pt-3 mt-2">
          <div className="text-small mb-2">شماره بلیط های استفاده شده: </div>
          <div className="d-flex">
            {item?.basketItemPersons?.map((ticket) => (
              <div className="mr-4 text-decoration-line-through">
                {ticket.id}
              </div>
            ))}
          </div>
        </div>
      </Accordion.Body>
    </>
  );
}
export default TickeInfoBox;
